
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetItembyId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"item"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"Name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sku_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"created_at"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"status"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"qty"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"instock"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"upc"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"msrp"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"vendorSku"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"uom"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"itemLength"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"itemWidth"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ItemHeight"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"itemWeight"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"upc2"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isbn"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"short_description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"long_description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"clothing_style"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"demo1"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"demo2"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pricelist_items"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attribute_set"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"short_description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"long_description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"clothing_style"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"demo1"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"demo2"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"main_image"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ext"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"additional_image"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ext"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":643}};
    doc.loc.source = {"body":"query GetItembyId($id: ID!) {\n  item(id: $id) {\n    id\n    Name\n    sku_id\n    created_at\n    status\n    qty\n    instock\n    upc\n    msrp\n    vendorSku\n    uom\n    itemLength\n    itemWidth\n    ItemHeight\n  itemWeight\n    upc2\n    isbn\n    short_description\n    long_description\n    clothing_style\n    demo1\n    demo2\n    pricelist_items{\n      id\n    }\n    product {\n      attribute_set\n      name\n      id\n      short_description\n      long_description\n      clothing_style\n      demo1\n      demo2\n    }\n    main_image {\n      id\n      url\n      name\n      ext\n    }\n    additional_image {\n      id\n      name\n      ext\n      url\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["GetItembyId"] = oneQuery(doc, "GetItembyId");
        
